import Collapse from "bootstrap/js/dist/collapse";

window.bootstrap = { Collapse };

export default Collapse;
